module.exports = __webpack_public_path__ + "img/56exp.d4294d78.jpg";